import React, { useState, useEffect } from "react";
import "../css/Modal.css";
import "../css/Onboarding.css";
import "../css/Icons.css";
import Modal from "react-modal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; // Import datepicker styles
import { FaCalendarAlt } from "react-icons/fa"; // Import a calendar icon
import CheckInStep1 from "../components/checkin/CheckInStep1";
import CheckInStep2 from "../components/checkin/CheckInStep2";
import CheckInStep3 from "../components/checkin/CheckInStep3";
import CheckInStep4 from "../components/checkin/CheckInStep4";
import CheckInDone from "../components/checkin/CheckInDone";
import OnboardingStep6 from "../components/OnboardingStep6";
import OnboardingStep7 from "../components/OnboardingStep7";
import OnboardingStep8 from "../components/OnboardingStep8";
import "../css/CheckIn.css";

const CheckIn = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [activeStep, setActiveStep] = useState(1);

  // Use an object to store active items for each step
  const [activeItems, setActiveItems] = useState({
    step1: [],
    step2: [],
    step3: [],
    step4: [],
    step5: [],
    step6: [],
    step7: [],
    step8: [],
  });

  const [selectedDate, setSelectedDate] = useState(() => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow;
  });

  const closeModal = () => setIsOpen(false);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  // Generic toggle function
  const toggleSubMenu = (step, item) => {
    setActiveItems((prevItems) => {
      const currentItems = prevItems[step];
      return {
        ...prevItems,
        [step]: currentItems.includes(item)
          ? currentItems.filter((activeItem) => activeItem !== item)
          : [...currentItems, item],
      };
    });
  };

  useEffect(() => {
    // Clear specific data from localStorage on first load
    localStorage.removeItem("activity_level");
    localStorage.removeItem("age");
    localStorage.removeItem("gender");
    localStorage.removeItem("is_preventive");
    localStorage.removeItem("motivation");
    localStorage.removeItem("onset_of_pain");
    localStorage.removeItem("pain_level");
    localStorage.removeItem("patient_name");
    localStorage.removeItem("personal_goal");
    localStorage.removeItem("surgery_date");
    localStorage.removeItem("day_zero");
    localStorage.removeItem("which_knee");
  }, []);

  return (
    <div>
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        className={`onboarding-modal recovery-checkin-modal step-${activeStep} custom-modal-style`}
      >
        {activeStep !== 1 && activeStep !== 5 && activeStep !== 8 && (
          <div className="back-btn-container flex gap-10" onClick={handleBack}>
            <img src="../backButton.svg" alt="back" className="back-btn" /> Back
          </div>
        )}
        {activeStep === 1 && (
          <CheckInStep1
            activeItems={activeItems.step1}
            toggleSubMenu={(item) => toggleSubMenu("step1", item)}
            selectedDate={selectedDate}
            handleDateChange={handleDateChange}
            handleNext={handleNext}
          />
        )}
        {activeStep === 2 && (
          <CheckInStep2
            activeItems={activeItems.step2}
            toggleSubMenu={(item) => toggleSubMenu("step2", item)}
            handleNext={handleNext}
          />
        )}
        {activeStep === 3 && (
          <CheckInStep3
            activeItems={activeItems.step3}
            toggleSubMenu={(item) => toggleSubMenu("step3", item)}
            handleNext={handleNext}
          />
        )}
        {activeStep === 4 && (
          <CheckInStep4
            activeItems={activeItems.step4}
            toggleSubMenu={(item) => toggleSubMenu("step4", item)}
            handleNext={handleNext}
          />
        )}
        {activeStep === 5 && (
          <CheckInDone
            activeItems={activeItems.step5}
            toggleSubMenu={(item) => toggleSubMenu("step5", item)}
            handleNext={handleNext}
          />
        )}
        {/* {activeStep === 6 && (
          <OnboardingStep6
            activeItems={activeItems.step6}
            toggleSubMenu={(item) => toggleSubMenu("step6", item)}
            handleNext={handleNext}
          />
        )}
        {activeStep === 7 && (
          <OnboardingStep7
            activeItems={activeItems.step7}
            toggleSubMenu={(item) => toggleSubMenu("step7", item)}
            handleNext={handleNext}
          />
        )}
         {activeStep === 8 && (
          <OnboardingStep8
            activeItems={activeItems.step8}
            toggleSubMenu={(item) => toggleSubMenu("step8", item)}
            handleNext={handleNext}
          />
        )} */}
      </Modal>
    </div>
  );
};

export default CheckIn;
